var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoW(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 168.716,
    height: 165.045,
    viewBox: "0 0 168.716 165.045",
    fill: "none",
    id: "svg12",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_161_1062)",
    id: "g12",
    transform: "translate(-363.062)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 379.206,118.017 h 60.639 v 14.349 H 363.062 V 0 h 16.144 z",
    fill: "#000000",
    id: "path3",
    style: {
      fill: "#ffffff",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 422.639,118.017 h 60.638 v 14.349 H 406.494 V 0 h 16.145 z",
    fill: "#000000",
    id: "path4",
    style: {
      fill: "#ffffff",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 466.033,118.017 h 56.659 v 14.349 H 449.889 V 0 h 16.144 z",
    fill: "#000000",
    id: "path5",
    style: {
      fill: "#ffffff",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 509.598,118.017 h 22.167 v 14.349 H 493.453 V 0 h 16.145 z",
    fill: "#000000",
    id: "path6",
    style: {
      fill: "#ffffff",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 520.688,130.242 c -1.181,0 -2.295,-0.118 -3.356,-0.303 v 19.056 H 363.301 v 16.05 h 168.477 v -38.627 c -2.746,2.347 -6.434,3.824 -11.077,3.824 z",
    fill: "#000000",
    id: "path7",
    style: {
      fill: "#ffffff",
      fillOpacity: 1
    }
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs12"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_161_1062"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1042,
    height: 165.045,
    fill: "#ffffff",
    id: "rect12",
    x: 0,
    y: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoW);
export default __webpack_public_path__ + "static/media/logo_w.15798fcbb40c56e70910f5f476f44151.svg";
export { ForwardRef as ReactComponent };